var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.001,
    height: 16.919,
    viewBox: "0 0 17.001 16.919",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "phone-call_1_",
    "data-name": "phone-call (1)",
    transform: "translate(0.503 0.498)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1637",
    "data-name": "Path 1637",
    d: "M4.406,6.546A13.28,13.28,0,0,0,6.368,9.3a11.241,11.241,0,0,0,3.111,2.3.323.323,0,0,0,.27.014,1.158,1.158,0,0,0,.374-.273,4.163,4.163,0,0,0,.341-.418c.5-.658,1.119-1.474,1.992-1.065.02.009.034.02.053.027l2.914,1.676c.009.005.02.014.027.02A1.314,1.314,0,0,1,16,12.706a3.072,3.072,0,0,1-.427,1.445,2.96,2.96,0,0,1-1.4,1.238,6.386,6.386,0,0,1-1.728.47,5.862,5.862,0,0,1-2.64-.22,11.712,11.712,0,0,1-2.655-1.281l-.069-.044c-.431-.27-.9-.557-1.354-.9a16.986,16.986,0,0,1-4.487-5.1A8.276,8.276,0,0,1,.075,3.085,3.757,3.757,0,0,1,1.347.7,3.411,3.411,0,0,1,3.883.022.366.366,0,0,1,4.176.21L6.044,3.369A.988.988,0,0,1,6.2,4.426a2.054,2.054,0,0,1-.715.8c-.1.086-.22.173-.346.264-.418.3-.893.654-.731,1.065l0-.01Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#2c728a",
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.e5e97fad62ca0e37d2b57ed675c58c25.svg";
export { ForwardRef as ReactComponent };